<template>
    <div>
        <v-dialog v-model="parameterdialog" max-width="600px">
            <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on" @click="resetSelections">+</v-btn>
            </template>
            <v-card>
                <v-card-title>
                    <span class="headline mb-4">{{ $t('attendanceincentivesetup.incentiveparameter') }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="12" md="12" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="$t('attendanceincentivesetup.selectdaytype')"
                                    type="text"
                                    dense
                                    multiple
                                    small-chips
                                    deletable-chips
                                    :rules="[rules.required]"
                                    :items="daytypeList"
                                    v-model="selections.daytypeids"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12" class="mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="$t('attendanceincentivesetup.selectshift')"
                                    type="text"
                                    dense
                                    multiple
                                    small-chips
                                    deletable-chips
                                    :rules="[rules.required]"
                                    :items="shiftList"
                                    v-model="selections.shiftids"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" sm="6" md="6" class="mt-n8">
                                <v-checkbox
                                    outlined
                                    v-model="selections.mustfulfillshifthours"
                                    :label="$t('setupforshift.mustfulfillshifthours')"
                                    dense
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="6" sm="6" md="6" class="mt-n8">
                                <v-text-field
                                    outlined
                                    :label="$t('setupforshift.minumumothours')"
                                    type="number"
                                    v-model="selections.minothours"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-text v-if="isErr" class="mt-n12">
                    <span style="font-weight: bold; color: red">{{ errMsg }}</span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closeParameterInput">Cancel</v-btn>
                    <v-btn color="green darken-1" text @click="saveParameterInput">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="eligibleGroupsDialog" max-width="1100px">
            <v-card>
                <v-card-title>
                    <span class="headline mb-4">{{ $t('attendanceincentivesetup.eligiblegroups') }}</span>
                </v-card-title>
                <v-card-text>
                    <app-eligible-groups-table
                        v-if="activeCondition"
                        :key="activeConditionKey"
                        v-bind:parentObject="{
                            tabHeader: parentObject.eligibleGroupsTabHeader,
                            detailItem: activeCondition.eligiblegroupdetail
                        }"
                        v-on:input="addEligibleGroupHandler"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" text @click="closeEligibleGroupsDialog">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            class="elavation-1"
            fixed-header
        >
            <template v-slot:item.action="{ item }">
                <v-icon small class="mr-2" @click="modifyItemHandler(item)">mdi-pen</v-icon>
                <v-icon small class="mr-2" @click="openEligibleGroupsHandler(item)">mdi-file-document-edit-outline</v-icon>
                <v-icon small class="mr-2" @click="deleteItemHandler(item)">mdi-delete</v-icon>
            </template>
            <template v-slot:item.mustfulfillshifthours="{ item }">
                {{ item.mustfulfillshifthours ? 'Yes' : 'No' }}
            </template>
        </v-data-table>
    </div>
</template>

<script>
import EligibleGroupsCRUDTable from './EligibleGroupsCRUDTable';

export default {
    props: {
        parentObject: Object
    },

    components: {
        'app-eligible-groups-table': EligibleGroupsCRUDTable,
    },

    data() {
        return {
            rules: {
                required: value => (Array.isArray(value) ? value.length > 0 : !!value) || this.$t('reportsparam.required'),
            },
            parameterdialog: false,
            eligibleGroupsDialog: false,
            activeCondition: null,
            activeConditionKey: 0,
            loadedConditionIds: new Set(),
            detailItem: this.parentObject.detailItem,
            selections: this.emptySelections(),
            daytypeList: [],
            daytypeItems: [],
            shiftList: [],
            shiftItems: [],
            itemHolder: null,
            isExisting: false,
            isErr: false,
            errMsg: '',
        }
    },

    methods: {
        emptySelections() {
            return {
                id: null,
                daytypeids: [],
                daytypecodes: '',
                shiftids: [],
                shiftcodes: '',
                shiftdescs: '',
                mustfulfillshifthours: false,
                minothours: null,
                eligiblegroupdetail: [],
                action: 0,
                stamp: 0,
            };
        },

        loadDayTypes() {
            const vm = this;
            this.$store.dispatch('get', { url: '/daytype/all' })
                .then(res => {
                    vm.daytypeItems = res.data.rec;
                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.daytypeList.push({
                            text: res.data.rec[i].daytypedesc,
                            value: res.data.rec[i].id,
                        });
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                });
        },

        loadShifts() {
            const vm = this;
            this.$store.dispatch('get', { url: '/shiftsetup/all' })
                .then(res => {
                    vm.shiftItems = res.data.rec;
                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.shiftList.push({
                            text: res.data.rec[i].shiftcode,
                            value: res.data.rec[i].id,
                        });
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                });
        },

        modifyItemHandler(item) {
            this.isExisting = true;
            this.itemHolder = item;
            this.selections = {
                ...item,
                daytypeids: Array.isArray(item.daytypeids) ? [...item.daytypeids] : [],
                shiftids: Array.isArray(item.shiftids) ? [...item.shiftids] : [],
                eligiblegroupdetail: Array.isArray(item.eligiblegroupdetail) ? item.eligiblegroupdetail : [],
            };
            this.parameterdialog = true;
        },

        deleteItemHandler(item) {
            let itemIndex = this.detailItem.indexOf(item);
            this.detailItem.splice(itemIndex, 1);
            this.$emit('input', this.detailItem);
        },

        async openEligibleGroupsHandler(item) {
            if (!Array.isArray(item.eligiblegroupdetail)) {
                this.$set(item, 'eligiblegroupdetail', []);
            }

            if (item.id && !this.loadedConditionIds.has(item.id)) {
                try {
                    const res = await this.$store.dispatch('get', { url: '/attendanceincentivesetupg/' + item.id });
                    const rec = res.data.rec || [];
                    const groupIdFields = ['workgroupids', 'compnyids', 'branchids', 'deptids', 'divisionids', 'sectionids', 'unitids', 'emptypeids', 'gradeids', 'jobids', 'positionids'];
                    for (let i = 0; i < rec.length; i++) {
                        const group = rec[i];
                        Object.assign(group, { action: 2 });
                        for (const field of groupIdFields) {
                            if (!Array.isArray(group[field])) {
                                group[field] = group[field] ? String(group[field]).split(',').map(Number) : [];
                            }
                        }
                    }
                    this.$set(item, 'eligiblegroupdetail', rec);
                    this.loadedConditionIds.add(item.id);
                    this.$emit('input', this.detailItem);
                } catch (err) {
                    this.isErr = true;
                    this.errMsg = err;
                    return;
                }
            }

            this.activeCondition = item;
            this.activeConditionKey++;
            this.eligibleGroupsDialog = true;
        },

        addEligibleGroupHandler($event) {
            if (this.activeCondition) {
                this.activeCondition.eligiblegroupdetail = $event;
                this.$emit('input', this.detailItem);
            }
        },

        closeEligibleGroupsDialog() {
            this.eligibleGroupsDialog = false;
            this.activeCondition = null;
        },

        saveParameterInput() {
            if (!this.selections.daytypeids || this.selections.daytypeids.length === 0) {
                this.isErr = true;
                this.errMsg = this.$t('attendanceincentivesetup.fillindaytype');
                return;
            }
            if (!this.selections.shiftids || this.selections.shiftids.length === 0) {
                this.isErr = true;
                this.errMsg = this.$t('attendanceincentivesetup.fillinshift');
                return;
            }
            this.isErr = false;

            const selectedDayTypes = this.daytypeItems.filter(item => this.selections.daytypeids.includes(item.id));
            const selectedShifts = this.shiftItems.filter(item => this.selections.shiftids.includes(item.id));

            const rowData = {
                ...this.selections,
                daytypeids: [...this.selections.daytypeids],
                shiftids: [...this.selections.shiftids],
                eligiblegroupdetail: Array.isArray(this.selections.eligiblegroupdetail) ? this.selections.eligiblegroupdetail : [],
                daytypecodes: selectedDayTypes.map(d => d.daytypecode).join(', '),
                shiftcodes: selectedShifts.map(s => s.shiftcode).join(', '),
                shiftdescs: selectedShifts.map(s => s.shiftdesc).join(', '),
            };

            if (this.isExisting) {
                const index = this.detailItem.findIndex(item => item === this.itemHolder);
                if (index !== -1) {
                    this.$set(this.detailItem, index, { ...rowData, action: this.itemHolder.action });
                }
            } else {
                rowData.id = null;
                rowData.action = 1;
                this.detailItem.push(rowData);
            }

            this.$emit('input', this.detailItem);
            this.parameterdialog = false;
            this.resetSelections();
        },

        closeParameterInput() {
            this.parameterdialog = false;
            this.isErr = false;
            this.isExisting = false;
            this.resetSelections();
        },

        resetSelections() {
            this.selections = this.emptySelections();
            this.isExisting = false;
            this.itemHolder = null;
        },
    },

    created() {
        this.loadDayTypes();
        this.loadShifts();
    }
}
</script>
